<template>
  <div class="bs-docs-section mx-3 my-3 page-wrap">
    <div class="profile-section">
      <div class="row">
        <div class="col-md-12 text-center mb-2 pt-1">
          <h4>Submit Resume</h4>
          <hr class="w-80" />
        </div>
      </div>
      <div class="row">
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSeWRrVg5nczcnxEKvoBiuf-wCtqM_ptplmxYiWVA7U1Z-zhDg/viewform?embedded=true"
          width="90%"
          height="800px"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/finult-pages.css";
import "@/assets/css/blogs.css";
export default {
  name: "SubmitProfile",
  metaInfo: {
    title: "Submit Profile"
  },
  data() {
    return {};
  }
};
</script>

<style></style>
